import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Dialog } from '@root/shared/ui-kit'

import { GasSettingsForm } from '../../common/gas-settings/gas-settings-form'

import type { TransferGasSettingsReatom } from '../../../atoms/transfer-fee-reatom'
import type { DialogProps } from '@root/shared/ui-kit'

type GasSettingsModalProps = {
  gasSettingsModel: TransferGasSettingsReatom
} & Pick<DialogProps, 'onOpenChange' | 'open'>

export const GasSettingsModal: React.FC<GasSettingsModalProps> = ({
  open,
  onOpenChange,
  gasSettingsModel,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      variant="functional"
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('gas-settings.change-gas-settings')}
    >
      <Dialog.Header title={t('gas-settings.change-gas-settings')} />
      <Form
        gasSettingsModel={gasSettingsModel}
        onDone={() => {
          onOpenChange?.(false)
        }}
      />
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 360px;
`
const Form = styled(GasSettingsForm)`
  padding-block: 8px;
`
